<template>
  <div class="job-level">
    <basiCcontainer>
      <template #head>
        <div class="job-level-header">
          职位管理
        </div>
      </template>
      <div class="yg-style">
        <div class="slecle-department-tree">
          <div class="search-input">
            <el-input prefix-icon="icon iconfont iconicon_search1" size="mini" placeholder="搜索分组名称" clearable v-model="filterText">
            </el-input>
            <span class="add-btn" @click="addOnceTree" v-permission="'岗位管理-新增岗位分类'">
              <i class="icon iconfont iconicon_enlarge"></i>
            </span>
          </div>
          <div class="treeLeft" v-loading="treeLoading">
            <div width="100%" class="tree-box">
              <el-tree v-if="jobInfo.id" ref="tree" :default-expanded-keys="expandedKeys" :current-node-key="jobInfo.id" @node-click="handleNodeClick" :data="treeDataset" node-key="id" :props="propsNode" highlight-current :filter-node-method="filterNode">
                <span class="custom-tree-node" slot-scope="{ node,data }">
                  <span class="edit-txt">{{ node.label}}</span>
                  <span
                    class="edit-icon"
                    @click.stop="editDepartment(data)"
                    v-if="data.job_type_name !== '默认分组'"
                  >
                    <el-tooltip placement="top" content="编辑分组">
                      <i v-permission="'岗位管理-更新岗位分类'" class="icon iconfont iconicon_input tableIconHover "></i>
                    </el-tooltip>
                  </span>
                </span>
              </el-tree>
            </div>
          </div>
          <!-- <div class="buttom-flex">
            <wf-button icon="icon iconfont iconicon_enlarge" @click="addOnceTree" auto v-permission="'岗位管理-新增岗位分类'">添加分组</wf-button>
          </div> -->
        </div>
        <div class="yg-style-right">
          <commonTable tableHead="jobLevel" :config="{nothing}" @button-click="addUserjob" :apiUrl="{url:'jobLevel',methods:'getUserJobLevel'}" ref="commonTable" :params="ruleForm" @handleSelectionChange="handleSelectionChange" :selection="true" :tipShow="false" :verifyRemark="true" :popover="false">
            <template #table_head>
              <div class="search-table">
                <p v-if="jobInfo.job_type_name">
                  {{ jobInfo.job_type_name }}
                  <span>{{ `(${ jobInfo.users_count })` }}</span>
                </p>
                <div class="search-table-tool">
                  <div class="btns">
                    <wf-button type="primary" :icon="'icon iconfont iconicon_enlarge'" @click="addUserjob" style="margin-right:12px;" v-permission="'岗位管理-新增岗位'">新增职位</wf-button>
                    <wf-button type="primary" :icon="'icon iconfont iconicon_delete'" plain :disabled="selectionArr.length === 0" @click="delUserjobArr" v-permission="'岗位管理-删除岗位'">删除职位</wf-button>
                  </div>
                  <el-input prefix-icon="iconfont iconicon_search1" @input="searchChange" class="fliter-input" v-model="ruleForm.keyword" size="mini" placeholder="搜索职位名称" clearable @keyup.enter.native="$refs.commonTable.getTableList()"></el-input>
                </div>
              </div>
            </template>
            <template slot="verifyRemark" slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand($event, scope.data)" placement="bottom-start">
                <i class="icon iconfont iconicon_more_task1 tableIconHover"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="update"
                    icon="icon iconfont iconicon_input"
                    v-permission="'岗位管理-更新岗位'"
                  >
                    编辑信息
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="warning"
                    command="delete"
                    icon="icon iconfont iconicon_delete"
                    v-permission="'岗位管理-删除岗位'"
                  >
                    删除职位
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <span @click="editUserjob(scope.data)" v-permission="'岗位管理-更新岗位'">修改</span>
              <span @click="delUserjob(scope.data)" v-permission="'岗位管理-删除岗位'">删除</span> -->
            </template>
          </commonTable>
        </div>
      </div>
    </basiCcontainer>

    <!-- 新增、编辑 分组弹窗 -->
    <Add-group-dialog
      v-if="addJobVisible"
      :dialogShow="addJobVisible"
      :dataset="dataset"
      :isEdit="isEdit"
      @complete="complete"
      @handleClose="addJobVisible = false"
    ></Add-group-dialog>

    <!-- 职位弹窗 -->
    <Job-dialog
      v-if="dialogVisible"
      :dialogShow="dialogVisible"
      :dataset="datasetJob"
      :treeDataset="treeDataset"
      :isEdit="isEdit"
      @complete="complete"
      @handleClose="dialogVisible = false"
    ></Job-dialog>

    <!-- <el-drawer :title="!isEdit ? '新增分组' : '编辑分组'" :visible.sync="addJobVisible" :wrapperClosable="false" :append-to-body="false" size="500px" @close="isEdit = false">
      <addDialog @cancel="addJobVisible = false" :visible="addJobVisible" :isEdit="isEdit" :isParent="isParent" :dataset="dataset" @complete="complete" @delete="deleteJob" />
    </el-drawer>
    <el-drawer :title="!isEdit ? '新增职位信息' : '更新职位信息'" :visible.sync="dialogVisible" :wrapperClosable="false" :append-to-body="false" size="500px" @close="isEdit = false">
      <addUserJob @cancel="dialogVisible = false" :treeDataset="treeDataset" :visible="dialogVisible" :isEdit="isEdit" :isParent="isParent" :dataset="datasetJob" @complete="complete" />
    </el-drawer> -->
  </div>
</template>

<script>
import api from '@/services/api/jobLevel/jobLevel'
// import addDialog from './addDialog'
// import addUserJob from './addUserJob'
import { mapMutations } from 'vuex'

//组件
import AddGroupDialog from './components/addGroupDialog.vue'
import JobDialog from './components/jobDialog.vue'

export default {
  components: {
    // addDialog,
    // addUserJob
    AddGroupDialog,
    JobDialog
  },
  data() {
    return {
      dialogVisible: false,
      addJobVisible: false,
      treeLoading: false,
      tableData: [],
      expandedKeys: [],
      treeDataset: [],
      jobInfo: [],
      selectionArr: [],
      dataset: {},
      datasetJob: {},
      isEdit: false,
      isParent: false,
      loading: false,
      filterText: '',
      nothing: {
        tip: '暂无职位，快去添加职位吧',
        type: 'img_add_task',
        btnText: '添加职位',
        permission: ''
      },
      ruleForm: {
        keyword: '',
        job_type_id: ''
      },
      propsNode: {
        label: 'job_type_name'
      },
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async complete(pid, isParent) {
      this.dialogVisible = false
      this.addJobVisible = false
      this.isEdit = false
      this.isParent = false
      await this.getTreeData()
      this.$refs.commonTable.getTableList()
      this.reschTreeCount()
    },
    reschTreeCount() {
      let tree = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === this.jobInfo.id) {
            this.jobInfo = ''
            this.treeLoading = true
            setTimeout(() => {
              this.jobInfo = data[i]
              this.treeLoading = false
            }, 300);
            return
          } else if (data[i].children) {
            tree(data[i].children)
          }
        }
      }
      tree(this.treeDataset)
    },
    deleteJob() {
      this.dialogVisible = false
      this.addJobVisible = false
      this.isEdit = false
      this.isParent = false
      this.init()
    },
    async init() {
      this.treeLoading = true
      await this.getTreeData()
      this.treeLoading = false
      this.jobInfo = this.treeDataset[0]
      this.ruleForm.job_type_id = this.treeDataset[0] ? this.treeDataset[0].id : ''
      this.$refs.commonTable.getTableList()
    },
    getTreeData() {
      return api.jobTypeList({ pid: 0, level: 10 }).then(res => {
        this.expandedKeys = res.data.map(item => item.id)
        let tree = (dataset) => {
          dataset.map(item => {
            if (item.children && item.children.data) {
              item.children = item.children.data
            } else {
              return
            }
            if (item.children && item.children.length > 0) {
              tree(item.children)
            }
          })
        }
        tree(res.data)
        this.treeDataset = res.data
      })
    },
    load(tree, treeNode, resolve) {
      api.jobTypeList({ pid: tree.id, level: 1 }).then(res => {
        resolve(res.data)
      })
    },
    addDepartment(data) {
      this.dataset = JSON.parse(JSON.stringify(data))
      this.dialogVisible = true
      this.isEdit = false
      this.isParent = false
    },
    handleNodeClick(data, checked, indeterminate) {
      this.jobInfo = data
      this.ruleForm.job_type_id = data.id || ''
      this.$refs.commonTable.getTableList()
    },
    editDepartment(data) {
      this.isEdit = true
      this.addJobVisible = true
      this.dataset = JSON.parse(JSON.stringify(data))
      if (data.pid == 0) {
        this.isParent = true
      } else {
        this.isParent = false
      }
    },
    addOnceTree() {
      this.isParent = true
      this.isEdit = false
      this.addJobVisible = true
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.job_type_name.indexOf(value) !== -1;
    },
    searchChange() {
      clearInterval(this.timer)
      this.timer = ''
      this.timer = setInterval(() => {
        this.$refs.commonTable.getTableList()
        clearInterval(this.timer)
        this.timer = ''
      }, 300)
    },
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.selectionArr = val.map(res => res.id)
      } else {
        this.selectionArr = []
      }
    },
    addUserjob() {
      this.datasetJob = JSON.parse(JSON.stringify(this.jobInfo))
      this.isParent = true
      this.dialogVisible = true
    },
    handleCommand(command, data) {
      if (command === 'update') {
        // 更新岗位
        this.editUserjob(data)
      } else if (command === 'delete') {
        // 删除岗位
        this.delUserjob(data)
      }
    },
    editUserjob(data) {
      this.datasetJob = JSON.parse(JSON.stringify(data))
      this.isEdit = true
      this.dialogVisible = true
    },
    async delUserjobArr() {
      if (this.selectionArr.length === 0) {
        this.$message({
          message: '请勾选职位再进行操作',
          type: 'warning'
        });
        return
      }
      await this.$wfAlert('warning', `确定删除${this.selectionArr.length}个职位?`,'删除后不可恢复。' )
      await api.deleteUserJob({ job_ids: this.selectionArr })
      this.complete()
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
    },
    async delUserjob(data) {
      await this.$wfAlert('warning', `确定删除职位${data.job_name}?`)
      await api.deleteUserJob({ job_ids: [data.id] })
      this.complete()
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
    }
  }
}
</script>
<style lang="scss" src="./style.scss">
</style>
